

// list of products with an associated subscription (will ONLY offer subscription, no one-time purchase)
const SUBSCRIBABLE_PRODUCTS = [
	"LuxPlay + LuxStudio Subscription",
	"LuxOmni + LuxStudio Subscription",
	"LuxOmni"
]

// product which needs to use
const SUBSCRIBABLE_PRODUCTS_TO_MODIFY = ["LuxOmni + LuxStudio Subscription", "LuxOmni"]
// the subscription price to use for the above product
const SUBSCRIBABLE_PRODUCT_MODIFIED_PRICE = '$499.00'

/**
 * Appends a change event listener so when a product variant is selected, 
 * the seal subscription widget gets modified to hide one-time purchase options and 
 * clearly show the subscription payment details
 */
function initialize() {

	// Use product section as the root to avoid re-rendering children elements removing event listeners
	const productSection = document.querySelector("product-info")

	// on child input change, check if the product is a subscribable
	productSection.addEventListener("change", (e) => {

		if (e.target.hasAttribute("data-product-url")) {
			const selectedProductName = e.target.value

			if (SUBSCRIBABLE_PRODUCTS.includes(selectedProductName)) {
				// if the selected product is one of the subscribable ones, hide the onetime purchase option
				hideOneTimeOption()
			} else {
				// otherwise, show the onetime purchase option
				showOneTimeOption()
			}

			initSubscriptionListeners()
		}

	})

	const product = window.meta?.product
	if (product) {
		const variant = product.variants?.[0]

		console.log("GOT VARIANT!!!!!", variant)

		if (variant && SUBSCRIBABLE_PRODUCTS_TO_MODIFY.includes(variant.name)) {
			updateSubscriptionDetails()
		}

	}


	// Wait for sealsubs DOM elements to mount, then trigger the change event
	const mutationObserver = new MutationObserver((mutations, observer) => {
		for (const mutation of mutations) {
			if (mutation.type === "childList") {
				mutation.addedNodes.forEach((node) => {
					if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains("sealsubs-target-element")) {
						clickSubscriptionOption()
						initVariantImageSwitching()
						observer.disconnect()
					}
				})
			}
		}
	})
	
	mutationObserver.observe(productSection, {
		childList: true,
		attributes: false, 
		characterData: false, 
		subtree: true
	})
}

// #region Subscription details

/**
 * Click both subscribable products to FORCE a change event
 */
function clickSubscriptionOption() {

	const variantOption1 = document.querySelector(`input[value="${SUBSCRIBABLE_PRODUCTS[0]}"]`)
	const variantOption2 = document.querySelector(`input[value="${SUBSCRIBABLE_PRODUCTS[1]}"]`)

	// Forces a CHANGE event which fixes the shown purchase options (see in initialize)
	variantOption2.click()
	setTimeout(() => {
		variantOption1.click()
	}, 200)

}

/**
 * Handles a listener trigger in order to call modifySubscriptionDetails
 */
const updateSubscriptionDetails = (e) => {
	setTimeout(() => {
		modifySubscriptionDetails()
	}, 100)
	document.removeEventListener("sealsubs:price_update", updateSubscriptionDetails)
}

/**
 * Resets the listeners for the subscription change
 */
function initSubscriptionListeners() {
	document.removeEventListener("sealsubs:price_update", updateSubscriptionDetails)
	document.addEventListener("sealsubs:price_update", updateSubscriptionDetails)
}

/**
 * Shows the one-time purchase option (from seal subscription widget)
 */
function showOneTimeOption() {
	const oneTimePurchaseOption = document.querySelector(".sls-purchase-options-container .sls-option-container:not([data-selling-plan-group-id])")
	if (!oneTimePurchaseOption) return

	oneTimePurchaseOption.style.display = ""

}

/**
 * Hides the one-time purchase option (from seal subscription widget)
 */
function hideOneTimeOption() {
	const oneTimePurchaseOption = document.querySelector(".sls-purchase-options-container .sls-option-container:not([data-selling-plan-group-id])")
	if (!oneTimePurchaseOption) return

	oneTimePurchaseOption.style.display = "none"
}

/**
 * Modifies the subscription details of the active subscription option to show first payment price and annual billing price (this is set above)
 */
function modifySubscriptionDetails() {

	// find the subscription (not one-time purchase) option and click it (setting it as the active option) 
	const subscriptionPurchaseOption = document.querySelector(`.sls-purchase-options-container .sls-option-container[data-selling-plan-group-id]:not(.sls-disabled-option-container)`)
	if (!subscriptionPurchaseOption) return

	const radioInput = subscriptionPurchaseOption.querySelector(`input[type="radio"]`)
	radioInput?.click()

	// modify wording with price now and annual price
	const priceLabelContainer = subscriptionPurchaseOption.querySelector(".sls-price-below")
	priceLabelContainer.textContent = 'now'

	const planDetails = subscriptionPurchaseOption.querySelector(".selling-plan-group-options-name-select")
	const labels = planDetails.querySelectorAll("label")
	labels.forEach((label) => label.style.display = "none")

	const newLabel = document.createElement("label")
	newLabel.textContent = `${SUBSCRIBABLE_PRODUCT_MODIFIED_PRICE} billed annually`
	planDetails.prepend(newLabel)

}

// #endregion
// #region Media swap

// Helpers
function getProductSection() {
	return document.querySelector('product-info');
}

function getVariants() {
	const productSection = document.querySelector('product-info');
	const sectionId = productSection?.dataset.section; // ← comes from your Liquid

	console.log(sectionId)
	if (!sectionId) return [];
	const el = document.getElementById(`variant-data-${sectionId}`);
	console.log(el)
	if (!el) return [];

	console.log(el)
	try { return JSON.parse(el.textContent); } catch (e) { return []; }
}

// Build mediaId -> slideIndex map from current DOM order
function buildMediaIndexMap() {
	const map = new Map();
	document.querySelectorAll('.product-media-slider .main-images .image-item').forEach((el, idx) => {
		const mid = el.getAttribute('data-media-id');
		if (mid) map.set(String(mid), idx);
	});
	return map;
}

// Figure out selected variant id/name (works with select or pill radios)
function getSelectedVariantId(productSection, variants) {
	// 1) Native Shopify select (most reliable)
	const sel = productSection.querySelector('form[action*="/cart/add"] select[name="id"]');
	if (sel) return Number(sel.value);

	// 2) Pill radios (value contains label text)
	const checked = productSection.querySelector('.product-form__input--pill input[type="radio"]:checked');
	if (checked) {
		const txt = (checked.value || '').trim();
		const v = variants.find(v =>
			v.title === txt || v.name === txt || v.option1 === txt || v.option2 === txt || v.option3 === txt
		);
		if (v) return Number(v.id);
	}
	return null;
}

// Ensure slick is ready before calling slickGoTo
function withSlickReady(cb) {
	const $main = jQuery('.product-media-slider .main-images');
	if ($main.hasClass('slick-initialized')) {
		cb($main);
		return;
	}
	// If not initialized yet, run after init (once)
	$main.one('init.variantSwitch', function (e, slick) {
		cb(jQuery(slick.$slider));
	});
}

// Go to slide by media id
function goToMediaId(mediaId, mediaIndexMap) {
	if (!mediaId) return;
	const index = mediaIndexMap.get(String(mediaId));
	if (index == null) return;

	withSlickReady(($main) => {
		$main.slick('slickGoTo', index, true); // true = don't animate (optional)
		// thumbnails are linked via asNavFor, so they’ll sync automatically
	});
}

// Wire it up
function initVariantImageSwitching() {
	const productSection = getProductSection();
	if (!productSection) return;

	const variants = getVariants();
	const mediaIndexMap = buildMediaIndexMap();

	function onVariantChange() {
		const vid = getSelectedVariantId(productSection, variants);
		if (!vid) return;
		const v = variants.find(v => Number(v.id) === vid);
		const mediaId = v?.featured_media?.id;
		goToMediaId(mediaId, mediaIndexMap);
	}

	// 1) Run once (preselected variant)
	onVariantChange();

	// 2) React to user changes (your page already dispatches change events)
	productSection.addEventListener('change', (e) => {
		if (e.target?.name === 'id' || e.target?.hasAttribute?.('data-product-url')) {
			onVariantChange();
		}
	}, true);

	// 3) If your theme fires Dawn’s event, support it too (harmless if not present)
	document.addEventListener('variant:change', (ev) => {
		const mediaId = ev.detail?.variant?.featured_media?.id;
		if (mediaId) goToMediaId(mediaId, mediaIndexMap);
	});
}

// #endregion


document.addEventListener("DOMContentLoaded", initialize)

